import { put, select, takeLatest } from 'redux-saga/effects'
import { ExposureConstants } from '../store/exposure.constants'
import { setExposureList } from '../store/exposure.actions'
import { IExposureState } from '../store/exposure.types'
import { getExposureSelector } from '../selectors/getExposure.selector'
import { initialExposure } from '../store/exposure.reducers'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setExposureType() {
  const exposureState: IExposureState = yield select(getExposureSelector)
  const { exposureType, exposureTypePNNV, exposureList, crewId } = exposureState
  const selectedExposure = exposureList.find((exp) => exp.crewId === crewId)

  const updatedExposureType = exposureType.map((exp) => ({ ...exp, crewId }))

  try {
    if (selectedExposure) {
      selectedExposure.exposureType = updatedExposureType
      selectedExposure.exposureTypePNNV = exposureTypePNNV
      yield put(setExposureList(exposureList))
    } else {
      const copyExposureList = [
        ...exposureList,
        {
          ...initialExposure,
          crewId,
          exposureType: updatedExposureType,
          exposureTypePNNV,
        },
      ]
      yield put(setExposureList(copyExposureList))
    }
  } catch (e) {
    yield put(throwPcrException(`setExposureType() error: ${e}`))
  }
}
export function* setExposureTypeSaga() {
  yield takeLatest([ExposureConstants.SET_EXPOSURE_TYPE, ExposureConstants.SET_EXPOSURE_TYPE_PNNV], setExposureType)
}
